import axios from "axios";
import { apiEndpoint ,apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const device = {
  getList,
  storeOrUpdate,
  deleteDevice
};

function getList(propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.device}?property_id=${propertyId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 ){
          return res.data;
        }
      })
  );
}
function storeOrUpdate(data, id = null){
  return (id ? (
    axios
      .put(
        apiEndpointFunction.device(id),
        { device: data },
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        apiEndpoint.device,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if (res && res.status === 200 && res.data.code === "0000") {
      return res.data;
    }
    // Pass the error body through so callers can show field errors
    // (e.g. the Configure modal's phone call alarm number).
    return (res && res.data) || {};
  });
}
function deleteDevice(id){
  return (
    axios
      .delete(
        apiEndpointFunction.device(id),
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}
